import React, { useEffect, useState } from 'react';
import {
  Box, Chip, CircularProgress, Paper, Stack, Switch, Typography,
} from '@mui/material';
import { branchBankAccounts, branchToggleBankAccount } from '../../services/branchApi';

/* Branch picks which of its tier's pooled accounts it actively uses. Toggling
   on/off writes branch_bank_accounts and changes deposit routing immediately. */
export default function BranchBankAccounts() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState<number | null>(null);

  const load = async () => {
    setLoading(true);
    try { setRows((await branchBankAccounts()).available || []); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (id: number, enabled: boolean) => {
    setBusy(id);
    try { await branchToggleBankAccount(id, enabled); await load(); }
    catch (e: any) { alert(e.message); } finally { setBusy(null); }
  };

  if (loading) return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>Bank Accounts</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Accounts from your tier's pool. Enable the ones this branch should use for deposits.
      </Typography>
      <Stack spacing={1.5}>
        {rows.map((a) => (
          <Paper key={a.id} variant="outlined"
            sx={{ p: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Chip size="small" label={a.method} />
              <Chip size="small" variant="outlined" label={a.mode} />
              <Typography variant="body2">{a.label || '-'}</Typography>
              <Typography variant="body2" color="text.secondary">
                {a.method === 'UPI' ? a.upi_id : `${a.bank_name || ''} ${a.account_number || ''}`}
              </Typography>
              <Chip size="small" color={a.status === 'active' ? 'success' : 'warning'} label={a.status} />
            </Stack>
            <Switch checked={!!a.selected} disabled={busy === a.id || a.status !== 'active'}
              onChange={(e) => toggle(a.id, e.target.checked)} />
          </Paper>
        ))}
        {!rows.length && (
          <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
            No accounts in your tier's pool yet. Ask an admin to assign accounts to your tier.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
